/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessalreadyexistserror3Inputs */

const en_businessalreadyexistserror3 = /** @type {(inputs: Businessalreadyexistserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A business with this registration number already exists.`)
};

const de_businessalreadyexistserror3 = /** @type {(inputs: Businessalreadyexistserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Unternehmen mit dieser Registrierungsnummer existiert bereits.`)
};

/**
* | output |
* | --- |
* | "A business with this registration number already exists." |
*
* @param {Businessalreadyexistserror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessalreadyexistserror3 = /** @type {((inputs?: Businessalreadyexistserror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessalreadyexistserror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessalreadyexistserror3(inputs)
	return de_businessalreadyexistserror3(inputs)
});
export { businessalreadyexistserror3 as "businessAlreadyExistsError" }